var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "clearfix" },
          [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.oAssets + "/icode.webp", alt: "" }
            }),
            _vm._v(" "),
            _vm._l(_vm.menuList, function(item, index) {
              return _c(
                "p",
                {
                  key: index,
                  staticClass: "menu",
                  class: { highlight: item.path == _vm.$route.path }
                },
                [
                  _c("router-link", { attrs: { tag: "a", to: item.path } }, [
                    _vm._v(_vm._s(item.name))
                  ])
                ],
                1
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecebbf8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecebbf8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = null
// module chunks = 